/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  containerQueryProps,
  updateLocationBlogThunk,
} from '@resy/ui-kitchen';

import BlogContent from '../../components/BlogContent';

const BlogContentContainer = ({
  updateLocationBlogThunk,
  locationCode,
  containerQuery,
  heroIndex,
  locationTier,
}) => {
  useEffect(() => {
    if (locationCode) {
      updateLocationBlogThunk(locationCode);
    }
  }, [locationCode, updateLocationBlogThunk]);

  return (
    <BlogContent
      heroIndex={heroIndex}
      locationTier={locationTier}
      locationCode={locationCode}
      containerQuery={containerQuery}
    />
  );
};

BlogContentContainer.propTypes = {
  heroIndex: PropTypes.number,
  containerQuery: containerQueryProps,
  updateLocationBlogThunk: PropTypes.func.isRequired,
  locationCode: PropTypes.string.isRequired,
  locationTier: PropTypes.number.isRequired,
};

BlogContentContainer.defaultProps = {
  heroIndex: 0,
  containerQuery: {},
};

BlogContentContainer.displayName = 'BlogContentContainer';

const mapDispatchToProps = {
  updateLocationBlogThunk,
};

export { BlogContentContainer as ComponentUnderTest };
export default connect(null, mapDispatchToProps)(BlogContentContainer);
